/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// 1. React & Hooks
import React, { useState, useEffect, useRef } from 'react';
// 2. External libraries
import axios from 'axios';
import classnames from 'classnames';
import DatePicker, { registerLocale } from 'react-datepicker';
import FeatherIcon from 'feather-icons-react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ReactQuill from 'react-quill';
import Select from 'react-select';
import { toast, ToastContainer } from 'react-toastify';
import {
  normalizeProcurementDetail,
  FORM_INITIAL_STATE,
  denormalizeProcurementDetail,
  displayValue,
  formatSubmittedDate,
  getProcurementStatusConfig,
} from './utils/procurementHelpers';
import './ProcurementView.css';
import { formatDateTimeWithTimezone } from '../../utils/dateformatter';
import logger from '../../utils/logger';

// 3. CSS imports
import 'react-quill/dist/quill.snow.css';

import {
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  Spinner,
  Breadcrumb,
  BreadcrumbItem,
} from 'reactstrap';

// 5. Router
import { Link, useParams, useNavigate, data } from 'react-router-dom';

// 6. Data, konstanta, utils
import { incoTermTable, deliveryUnit } from '../../common/data';
import { orderSummary } from '../../common/data/ecommerce';
import { isNumericOnly } from '../../utils/validators';
import Swal from 'sweetalert2';

// 7. Local components
import BreadCrumb from '../../Components/Common/BreadCrumb';
import ActionMenu from './ActionMenu';
import DmutInvitationTab from './DmutInvitationTab';
import HpsRequestTab from './HpsRequestTab';
import OverviewTab from './OverviewTab';
import RequirementTab from './RequirementTab';
import SupportDocumentTab from './SupportDocumentTab';

// 8. Config & auth
import { api, web } from '../../config';
import { getAuthToken, isAuthenticated } from '../../auth/tokenvalidation';

// 9. Locale
import id from 'date-fns/locale/id';

// 10. Register locale & axios config
registerLocale('id', id);

axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const ProcurementForm = () => {
  const navigate = useNavigate();
  const token = getAuthToken();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCountry, setselectedCountry] = useState(null);
  const [selectedState, setselectedState] = useState(null);
  const [activeTab, setactiveTab] = useState(1);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [value, setValue] = useState('0');
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [ids] = useState(useParams().id);
  const [completedMode, setCompletedMode] = useState(false);
  const [dataCause, setDataCause] = useState({
    items: [],
  });

  const procurementTypeMap = {
    PelelanganKhusus: 'Pelelangan Khusus',
    PemilihanLangsung: 'Pemilihan Langsung',
    TunjukLangsung: 'Tunjuk Langsung',
  };

  const LoadDefault = () => {
    fetchDataProcurement(ids, setForm, token);
  };

  const [form, setForm] = useState(FORM_INITIAL_STATE);

  const fetchDataProcurement = async (ids, setForm, token) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${api.API_URL}/procurement/${ids}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: `application/json`,
        },
      });
      let apiResponse = response.data ?? response;
      const data =
        typeof apiResponse.data === 'object' && apiResponse.data !== null
          ? apiResponse.data
          : apiResponse;

      setForm(normalizeProcurementDetail(data));

      const quantityItems = (data.procurementClauseDetails || []).map(item => ({
        id: item.id ?? null,
        procurementId: item.procurementId ?? null,
        clauseDetailId: item.clauseDetailId ?? null,
        clauseTitle: item.clauseTitle ?? null,
        ordreNumber: item.ordreNumber ?? null,
        isShow: item.isShow ?? null,
        clauseDescription: item.clauseDescription ?? null,
        isShowToDMUT: item.isShowToDMUT ?? null,
      }));
      setDataCause({ items: quantityItems });
    } catch (error) {
      logger.warn('Error fetching data from  API:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const silentRefresh = async () => {
    try {
      const response = await axios.get(`${api.API_URL}/procurement/${ids}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });
      let apiResponse = response.data ?? response;
      const data =
        typeof apiResponse.data === 'object' && apiResponse.data !== null
          ? apiResponse.data
          : apiResponse;

      const normalized = normalizeProcurementDetail(data);
      const filtered = Object.fromEntries(
        Object.entries(normalized).filter(([, v]) => v != null)
      );
      setForm(prev => ({ ...prev, ...filtered }));

      const quantityItems = (data.procurementClauseDetails || []).map(item => ({
        id: item.id ?? null,
        procurementId: item.procurementId ?? null,
        clauseDetailId: item.clauseDetailId ?? null,
        clauseTitle: item.clauseTitle ?? null,
        ordreNumber: item.ordreNumber ?? null,
        isShow: item.isShow ?? null,
        clauseDescription: item.clauseDescription ?? null,
        isShowToDMUT: item.isShowToDMUT ?? null,
      }));
      setDataCause({ items: quantityItems });
    } catch (error) {
      logger.warn('Silent refresh error:', error);
    }
  };

  const selectedFields = denormalizeProcurementDetail(form, dataCause);

  useEffect(() => {
    if (ids) {
      LoadDefault(ids, setForm, token);
    }
  }, [ids, token]);

  useEffect(() => {
    if (!ids || !token) return;

    autoSaveIntervalRef.current = setInterval(
      () => {
        if (form.isProcurementCompleted === false) {
          //handleAuthSaveProc();
          // toast.info('Data Automatically Updated', {
          //   position: 'top-right',
          //   autoClose: 3000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: false,
          // });
        }
      },
      2 * 60 * 1000
    );

    return () => {
      if (autoSaveIntervalRef.current) {
        clearInterval(autoSaveIntervalRef.current);
      }
    };
  }, [ids, token, form.isProcurementCompleted]);

  const handleSaveCompleteData = async ids => {
    try {
      await axios.post(
        `${api.API_URL}/procurement/SaveNextProcurement/${ids}`,
        null,
        {
          headers: {
            Accept: '*/*',
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      setError(error.message);
    } finally {
      LoadDefault();
    }
    // }
  };

  const handleSaveCompleteDocProc = async ids => {
    try {
      await axios.post(
        `${api.API_URL}/procurement/SaveNextSupportingDocuments/${ids}`,
        null,
        {
          headers: {
            Accept: '*/*',
            authentication: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      setError(error.message);
    } finally {
      LoadDefault();
    }
    // }
  };

  const dmutpayload = {
    justifikasi: null,
    procurementMitraFromDmut: form.procurementMitra,
  };

  const handleSaveCompleteDmutProc = async ids => {
    try {
      await axios.post(
        `${api.API_URL}/procurement/SaveNextDMUTInvitation/${ids}`,
        dmutpayload,
        {
          headers: {
            // Accept: '*/*',
            'Content-Type': 'application/json',
            authentication: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      setError(error.message);
    } finally {
      LoadDefault();
    }
    // }
  };

  const handleSaveDraftProc = () => {
    if (validatedeliveryModal()) {
      handleSaveProc();
    }
  };

  const autoSaveIntervalRef = useRef(null);

  const handleSaveCompleteProc = () => {
    if (validatecompleteProc()) {
      handleSaveCompleteData(ids);
      handleSaveProc();
    }
  };

  const handleSaveCompleteDoc = () => {
    handleSaveCompleteDocProc(ids);
    handleSaveProc();
  };

  const handleSaveCompleteDmut = () => {
    handleSaveCompleteDmutProc(ids);
    handleSaveProc();
  };

  const handleSaveProc = async e => {
    try {
      const formData = new FormData();
      formData.append('data', JSON.stringify(selectedFields));
      // formData.append('documentNotaDinas', file); // opsional
      await axios.put(`${api.API_URL}/procurement/${ids}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      setError(error.message);
    } finally {
      toast.success(`Data Has Been Saved `);
      LoadDefault();
    }
  };

  const handleAuthSaveProc = async e => {
    try {
      const formData = new FormData();
      formData.append('data', JSON.stringify(selectedFields));
      const response = await axios.put(
        `${api.API_URL}/procurement/${ids}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      setError(error.message);
    } finally {
      silentRefresh();
    }
  };

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];

      if (tab >= 1 && tab <= 5) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  }

  const TAB_CONFIG = [
    { id: 1, icon: 'ri-list-ordered', label: 'REQUIREMENT' },
    { id: 2, icon: 'ri-file-text-line', label: 'SUPPORTING DOCUMENT' },
    { id: 3, icon: 'ri-mail-send-line', label: 'DMUT INVITATION' },
    {
      id: 4,
      icon: 'ri-checkbox-circle-line',
      label: 'HPS REQUEST',
      hideFromNav: true,
    },
    { id: 5, icon: 'ri-checkbox-circle-line', label: 'OVERVIEW' },
  ];
  const visibleNavTabs = TAB_CONFIG.filter(t => !t.hideFromNav);

  const isTabDone = tabId => activeTab <= 4 && tabId <= activeTab;

  const validatedeliveryModal = () => {
    let tempErrors = {};

    if (!form.contractType) {
      tempErrors.contractType = 'Please Select Contract Type';
    }

    if (!form.productTypeId) {
      tempErrors.productTypeId = 'Please Select';
    }

    if (!form.productNameId) {
      tempErrors.productNameId = 'Please Select';
    }

    if (!form.contractPeriodTermStart) {
      tempErrors.contractPeriodTermStart = 'Please Enter Start Date';
    }

    if (!form.contractPeriodTermEnd && parseInt(form.contractType, 10) === 1) {
      tempErrors.contractPeriodTermEnd = 'Please Enter End Date';
    }

    if (
      form.compositionMin != null &&
      form.compositionMax != null &&
      Number(form.compositionMin) > Number(form.compositionMax)
    ) {
      tempErrors.compositionMin =
        'Composition Min cannot be greater than Composition Max';
    }

    const compositionPairs = [
      {
        min: 'fullCargoVLGCRefrigratePropaneMin',
        max: 'fullCargoVLGCRefrigratePropaneMax',
        label: 'Full VLGC Propane',
      },
      {
        min: 'fullCargoVLGCRefrigrateButaneMin',
        max: 'fullCargoVLGCRefrigrateButaneMax',
        label: 'Full VLGC Butane',
      },
      {
        min: 'halfCargoVLGCRefrigratePropaneMin',
        max: 'halfCargoVLGCRefrigratePropaneMax',
        label: 'Half VLGC Propane',
      },
      {
        min: 'halfCargoVLGCRefrigrateButaneMin',
        max: 'halfCargoVLGCRefrigrateButaneMax',
        label: 'Half VLGC Butane',
      },
      {
        min: 'semiRefrigeratedRefrigratePropaneMin',
        max: 'semiRefrigeratedRefrigratePropaneMax',
        label: 'Semi Ref Propane',
      },
      {
        min: 'semiRefrigeratedRefrigrateButaneMin',
        max: 'semiRefrigeratedRefrigrateButaneMax',
        label: 'Semi Ref Butane',
      },
    ];

    compositionPairs.forEach(({ min, max, label }) => {
      const minVal = form[min];
      const maxVal = form[max];
      if (minVal != null && maxVal != null && Number(minVal) > Number(maxVal)) {
        tempErrors[min] = `${label}: Min cannot be greater than Max`;
      }
    });

    if (Object.keys(tempErrors).length !== 0) {
      //toast.warning("Please Check Mandatory Fields..");
      toast.error('Please Check Mandatory Fields..', {
        position: 'top-right',
        hideProgressBar: false,
        closeOnClick: false,
        className: 'bg-warning  text-black',
      });
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const validatecompleteProc = () => {
    const tempErrors = {};

    const requiredFields = [
      { field: 'contractType', message: 'Please Select Contract Type' },
      { field: 'productTypeId', message: 'Please Select' },
      { field: 'productNameId', message: 'Please Select' },
      {
        field: 'productSpecification',
        message: 'Please Describe for Product Specification',
      },
      { field: 'contractPeriodTermStart', message: 'Please Enter Date' },
      { field: 'proposalSubmissionDeadline', message: 'Please Enter Date' },
      { field: 'proposalValidityPeriodMax', message: 'Please Enter Date' },
      {
        field: 'contractPeriodTermEnd',
        message: 'Please Enter Date',
        condition: () => parseInt(form.contractType, 10) === 1,
      },

      {
        field: 'descriptionOfPaymentTerms',
        message: 'Please Describe for Description of Payment Term',
      },
      {
        field: 'otherTermsAndCondition',
        message: 'Please Describe for Other Terms & Condition',
      },
    ];

    requiredFields.forEach(({ field, message, condition }) => {
      const value = form[field];

      // Jika ada kondisi tambahan, cek dulu
      if (condition && !condition()) return;

      // Validasi kosong atau hanya <br>
      if (!value || value === '<br>') {
        tempErrors[field] = message;
      }
    });

    // Validate clause descriptions
    if (dataCause?.items) {
      dataCause.items.forEach(item => {
        const desc =
          dataCause.procurementClauseDetails?.find(
            d => String(d.id) === String(item.id)
          )?.clauseDescription ??
          item.clauseDescription ??
          '';

        if (!desc || desc === '<br>') {
          tempErrors[item.id] = `Please Describe for ${item.clauseTitle}`;
        }
      });
    }

    if (
      form.compositionMin != null &&
      form.compositionMax != null &&
      Number(form.compositionMin) > Number(form.compositionMax)
    ) {
      tempErrors.compositionMin =
        'Composition Min cannot be greater than Composition Max';
    }

    const compositionPairs = [
      {
        min: 'fullCargoVLGCRefrigratePropaneMin',
        max: 'fullCargoVLGCRefrigratePropaneMax',
        label: 'Full VLGC Propane',
      },
      {
        min: 'fullCargoVLGCRefrigrateButaneMin',
        max: 'fullCargoVLGCRefrigrateButaneMax',
        label: 'Full VLGC Butane',
      },
      {
        min: 'halfCargoVLGCRefrigratePropaneMin',
        max: 'halfCargoVLGCRefrigratePropaneMax',
        label: 'Half VLGC Propane',
      },
      {
        min: 'halfCargoVLGCRefrigrateButaneMin',
        max: 'halfCargoVLGCRefrigrateButaneMax',
        label: 'Half VLGC Butane',
      },
      {
        min: 'semiRefrigeratedRefrigratePropaneMin',
        max: 'semiRefrigeratedRefrigratePropaneMax',
        label: 'Semi Ref Propane',
      },
      {
        min: 'semiRefrigeratedRefrigrateButaneMin',
        max: 'semiRefrigeratedRefrigrateButaneMax',
        label: 'Semi Ref Butane',
      },
    ];

    compositionPairs.forEach(({ min, max, label }) => {
      const minVal = form[min];
      const maxVal = form[max];
      if (minVal != null && maxVal != null && Number(minVal) > Number(maxVal)) {
        tempErrors[min] = `${label}: Min cannot be greater than Max`;
      }
    });

    if (Object.keys(tempErrors).length > 0) {
      const msgList = Object.values(tempErrors);
      toast.error(
        <div>
          Please Check Mandatory Fields:
          <ul className='mb-0 mt-1' style={{ paddingLeft: '1.25rem' }}>
            {msgList.map((msg, idx) => (
              <li key={idx}>{msg}</li>
            ))}
          </ul>
        </div>,
        {
          position: 'top-right',
          hideProgressBar: true,
          closeOnClick: true,
          autoClose: false,
          className: 'bg-warning text-black toast-wide',
        }
      );
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  document.title = `Procurement Requirement - ${form.procurementNumber}`;

  const statusConfig = getProcurementStatusConfig(form?.isProcurementCompleted);

  const categoryLabel = form.procurementTypeHeaderLabel || 'Product Hydro';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1 '>
            <div className='email-content minimal-border'>
              <div className='p-4 pb-0'>
                <Row className='mt-n2 mb-1 mb-sm-0'>
                  <div className='col-sm order-3 order-sm-2'>
                    <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                      <h5 className='card-title mb-0 flex-grow-1'>
                        <Breadcrumb listClassName='p-3 py-2 bg-light'>
                          <BreadcrumbItem>
                            <Link to='/dashboard'>Home</Link>
                          </BreadcrumbItem>
                          <BreadcrumbItem>
                            <Link to='/apps-procurement/view'>
                              Plan & Procurement
                            </Link>
                          </BreadcrumbItem>
                          <BreadcrumbItem active>
                            Detail #
                            {displayValue(form?.procurementNumber || ids)}
                          </BreadcrumbItem>
                        </Breadcrumb>
                      </h5>
                    </div>
                  </div>
                </Row>

                <Row className='mb-4'>
                  <Col xs={12}>
                    <Row className='align-items-center g-3'>
                      <Col xs={12} lg>
                        <div className='d-flex align-items-start gap-3'>
                          <Button
                            color='light'
                            className='border shadow-sm rounded-circle d-flex align-items-center justify-content-center p-0'
                            style={{ width: '2.5rem', height: '2.5rem' }}
                            onClick={() => navigate('/apps-tenderopening/view')}
                          >
                            <i className='bx bx-arrow-back fs-5 text-dark'></i>
                          </Button>
                          <div className='flex-grow-1'>
                            {isLoading && !form ? (
                              <div className='d-flex align-items-center gap-2 py-2'>
                                <Spinner size='sm' color='primary' />
                                <span className='text-muted small'>
                                  Loading procurement...
                                </span>
                              </div>
                            ) : (
                              <>
                                <h4 className='mb-1 fw-bold text-dark'>
                                  {categoryLabel} —{' '}
                                  {displayValue(form?.titleProcurement)}
                                </h4>
                                <div className='d-flex flex-wrap align-items-center gap-2 text-muted small'>
                                  <i className='bx bx-hash'></i>
                                  <span>
                                    Procurement ID:{' '}
                                    {displayValue(form?.procurementNumber)}
                                  </span>

                                  <span className='d-none d-md-inline text-secondary opacity-25'>
                                    |
                                  </span>

                                  <i className='bx bx-calendar'></i>
                                  <span>
                                    {formatSubmittedDate(form?.createdDate)}
                                  </span>

                                  <span
                                    className={`badge ${statusConfig.className} fw-semibold px-3 py-1 rounded-pill`}
                                  >
                                    {statusConfig.label}
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr className='mt-3 mb-0 border-secondary opacity-10' />
                  </Col>
                </Row>

                <Row className='justify-content-center mb-4'>
                  <Col xxl={12}>
                    <CardBody className='checkout-tab'>
                      {/* <div className='step-arrow-nav mt-n3 mx-n3 mb-2 '> */}
                      <div className=' mx-n4 px-4 message-list-scroll'>
                        <Nav
                          tabs
                          className='nav-tabs-custom nav-primary mt-1 mb-3'
                        >
                          {visibleNavTabs.map(tab => (
                            <NavItem key={tab.id}>
                              <NavLink
                                className={classnames('cursor-pointer', {
                                  active: activeTab === tab.id,
                                  done: isTabDone(tab.id),
                                })}
                                onClick={() => toggleTab(tab.id)}
                              >
                                <i
                                  className={`${tab.icon} align-middle me-1`}
                                ></i>
                                <span className='fw-semibold'>{tab.label}</span>
                              </NavLink>
                            </NavItem>
                          ))}
                        </Nav>
                      </div>

                      <TabContent activeTab={activeTab}>
                        {TAB_CONFIG.map(tab => {
                          const tabProps = (() => {
                            switch (tab.id) {
                              case 1:
                                return {
                                  goNext: () => setactiveTab(2),
                                  ids,
                                  form,
                                  setForm,
                                  dataCause,
                                  setDataCause,
                                  handleSaveDraftProc,
                                  handleSaveCompleteProc,
                                  validatedeliveryModal,
                                  errors,
                                  setErrors,
                                  setIsLoading,
                                  isLoading,
                                  completedMode,
                                };
                              case 2:
                                return {
                                  goNext: () => setactiveTab(3),
                                  goBack: () => setactiveTab(1),
                                  ids,
                                  form,
                                  setForm,
                                  handleSaveDraftProc,
                                  handleSaveCompleteDoc,
                                  token,
                                  setIsLoading,
                                  isLoading,
                                };
                              case 3:
                                return {
                                  goNext: () => setactiveTab(5),
                                  goBack: () => setactiveTab(2),
                                  ids,
                                  form,
                                  setForm,
                                  token,
                                  setIsLoading,
                                  isLoading,
                                  handleSaveDraftProc,
                                  handleSaveCompleteDmut,
                                };
                              case 4:
                                return {
                                  goNext: () => setactiveTab(5),
                                  goBack: () => setactiveTab(3),
                                  ids,
                                  form,
                                };
                              case 5:
                                return {
                                  goBack: () => setactiveTab(3),
                                  ids,
                                  form,
                                  setForm,
                                  token,
                                  setIsLoading,
                                  isLoading,
                                  errors,
                                  setErrors,
                                };
                              default:
                                return {};
                            }
                          })();

                          const TabComponent = (() => {
                            switch (tab.id) {
                              case 1:
                                return RequirementTab;
                              case 2:
                                return SupportDocumentTab;
                              case 3:
                                return DmutInvitationTab;
                              case 4:
                                return HpsRequestTab;
                              case 5:
                                return OverviewTab;
                              default:
                                return null;
                            }
                          })();

                          if (!TabComponent) return null;

                          return (
                            <TabPane
                              key={tab.id}
                              tabId={tab.id}
                              {...(tab.id === 1
                                ? { id: 'pills-bill-info' }
                                : {})}
                              {...(tab.id === 5 ? { id: 'pills-finish' } : {})}
                            >
                              <TabComponent {...tabProps} />
                            </TabPane>
                          );
                        })}
                      </TabContent>
                    </CardBody>
                  </Col>
                </Row>
                <ToastContainer closeButton={false} limit={1} />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProcurementForm;
